import moment from 'moment';
import {joinedValuesSeparator, dateFormat} from '@/ts/DefaultTableConfigs';
import OrderLine from '@/ts/OrderLine';

export default class Order {

    public id: string;
    public unitId: string;
    public address: string;
    public date: string;
    public amount: number;
    public vatAmount: number;
    public totalAmount: number;
    public project: string;
    public unit: string;
    public daysOverdue: number;
    public description: string;
    public paymentDate: string;
    public type: string;
    public tenantType: string;
    public status: string;
    public isAutopaid: boolean;
    public transactionId: string;
    public paymentMethod: string;
    public completedRefundsAmount: number;
    public pendingRefundsAmount: number;
    public orderLines: OrderLine[];
    public remainingAmount: number;

    constructor(
         id: string,
         unitId: string,
         address: string,
         date: string,
         amount: number,
         vatAmount: number,
         totalAmount: number,
         project: string,
         unit: string,
         daysOverdue: number,
         description: string,
         tenantType: string,
         paymentDate: string = null,
         type: [] = [],
         status: string = null,
         isAutopaid: boolean = false,
         transactionId: string = null,
         paymentMethod: string = null,
         orderLines: OrderLine[] = [],
         completedRefundsAmount: number = 0,
         pendingRefundsAmount: number = 0,
         remainingAmount: number = 0,

    ) {
        this.id = id;
        this.unitId = unitId;
        this.address = address;
        this.date =  moment(date).local().format(dateFormat);
        this.amount = amount;
        this.vatAmount = vatAmount;
        this.totalAmount = totalAmount;
        this.project = project;
        this.unit = unit;
        this.daysOverdue = daysOverdue;
        this.description = description;
        this.tenantType = tenantType;
        this.paymentDate = moment(paymentDate).local().format(dateFormat);
        this.type = type.join(joinedValuesSeparator);
        this.status = status;
        this.isAutopaid = isAutopaid;
        this.transactionId = transactionId;
        this.paymentMethod = paymentMethod;
        this.orderLines = orderLines;
        this.completedRefundsAmount = completedRefundsAmount;
        this.pendingRefundsAmount = pendingRefundsAmount;
        this.remainingAmount = remainingAmount;
    }

    get momentDate() {
        return moment(this.date, dateFormat);
    }

    public compareDateAndReturnIfNotExists(date: any) {
        return typeof date === 'undefined' ? true : this.momentDate.isSameOrAfter(date.date);
    }
}
